import React, { useCallback, useMemo } from 'react';

import { loginFormId } from '@occc-app/Login/components/LoginForm';
import { useFormSubmit } from '@occc-app/hooks/useFormSubmit';
import { useRequestMagicLinkMutation } from '@occc-app/dataAccessLayer/auth/mutations';
import { MagicLinkRequestInput } from '@occc/graphql';

import Login from './Login';

const LoginContainer: React.FC = () => {
  const submitForm = useFormSubmit(loginFormId);

  const [requestMagicLink, { loading, error, data, reset }] = useRequestMagicLinkMutation();

  const onFormSubmit = useCallback(
    (input: MagicLinkRequestInput) => {
      requestMagicLink({
        variables: {
          input,
        },
      });
    },
    [requestMagicLink],
  );

  // Intentionally show the confirmation screen on any completed mutation without a transport error,
  // regardless of the boolean payload. Checking data.requestMagicLink would leak whether the email
  // is registered if the backend ever returns false for unknown addresses.
  const isMagicLinkRequested = useMemo(() => Boolean(data && !error), [data, error]);

  return (
    <Login
      isLoading={loading}
      isMagicLinkRequested={isMagicLinkRequested}
      submitForm={submitForm}
      onFormSubmit={onFormSubmit}
      onGoBack={reset}
    />
  );
};

export default LoginContainer;
